module.exports = __webpack_public_path__ + "static/img/securitybg3.7b55864.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/securitybg3.png
// module id = avAg
// module chunks = 1